import "/home/runner/work/pocket-dimension-dice/pocket-dimension-dice/components/Rollable/components/RollContextMenu/styles.module_built.css";
const classes = {"dieIcon":"_9OLh5G_dieIcon","diceNotation":"_9OLh5G_diceNotation","disabled":"_9OLh5G_disabled","list":"_9OLh5G_list","rollButtonTextSlot":"_9OLh5G_rollButtonTextSlot","check":"_9OLh5G_check","listItemButton":"_9OLh5G_listItemButton","rotateIcon":"_9OLh5G_rotateIcon","adjustDiceText":"_9OLh5G_adjustDiceText","adjustDiceButton":"_9OLh5G_adjustDiceButton","adjustDiceColumnText":"_9OLh5G_adjustDiceColumnText","menu":"_9OLh5G_menu","rollButtonText":"_9OLh5G_rollButtonText","section":"_9OLh5G_section","rollButton":"_9OLh5G_rollButton","diceAdjustmentContainer":"_9OLh5G_diceAdjustmentContainer","toggleSwitchWrapper":"_9OLh5G_toggleSwitchWrapper","heading":"_9OLh5G_heading","svg":"_9OLh5G_svg","adjustDiceTempSlot":"_9OLh5G_adjustDiceTempSlot","adjustDiceHeader":"_9OLh5G_adjustDiceHeader","adjustmentColumn":"_9OLh5G_adjustmentColumn","adjustDiceTempText":"_9OLh5G_adjustDiceTempText","dmgRollOption":"_9OLh5G_dmgRollOption"}
export default classes

const _dieIcon0 = classes["dieIcon"]
export { _dieIcon0 as "dieIcon" }

const _diceNotation0 = classes["diceNotation"]
export { _diceNotation0 as "diceNotation" }

const _disabled0 = classes["disabled"]
export { _disabled0 as "disabled" }

const _list0 = classes["list"]
export { _list0 as "list" }

const _rollButtonTextSlot0 = classes["rollButtonTextSlot"]
export { _rollButtonTextSlot0 as "rollButtonTextSlot" }

const _check0 = classes["check"]
export { _check0 as "check" }

const _listItemButton0 = classes["listItemButton"]
export { _listItemButton0 as "listItemButton" }

const _rotateIcon0 = classes["rotateIcon"]
export { _rotateIcon0 as "rotateIcon" }

const _adjustDiceText0 = classes["adjustDiceText"]
export { _adjustDiceText0 as "adjustDiceText" }

const _adjustDiceButton0 = classes["adjustDiceButton"]
export { _adjustDiceButton0 as "adjustDiceButton" }

const _adjustDiceColumnText0 = classes["adjustDiceColumnText"]
export { _adjustDiceColumnText0 as "adjustDiceColumnText" }

const _menu0 = classes["menu"]
export { _menu0 as "menu" }

const _rollButtonText0 = classes["rollButtonText"]
export { _rollButtonText0 as "rollButtonText" }

const _section0 = classes["section"]
export { _section0 as "section" }

const _rollButton0 = classes["rollButton"]
export { _rollButton0 as "rollButton" }

const _diceAdjustmentContainer0 = classes["diceAdjustmentContainer"]
export { _diceAdjustmentContainer0 as "diceAdjustmentContainer" }

const _toggleSwitchWrapper0 = classes["toggleSwitchWrapper"]
export { _toggleSwitchWrapper0 as "toggleSwitchWrapper" }

const _heading0 = classes["heading"]
export { _heading0 as "heading" }

const _svg0 = classes["svg"]
export { _svg0 as "svg" }

const _adjustDiceTempSlot0 = classes["adjustDiceTempSlot"]
export { _adjustDiceTempSlot0 as "adjustDiceTempSlot" }

const _adjustDiceHeader0 = classes["adjustDiceHeader"]
export { _adjustDiceHeader0 as "adjustDiceHeader" }

const _adjustmentColumn0 = classes["adjustmentColumn"]
export { _adjustmentColumn0 as "adjustmentColumn" }

const _adjustDiceTempText0 = classes["adjustDiceTempText"]
export { _adjustDiceTempText0 as "adjustDiceTempText" }

const _dmgRollOption0 = classes["dmgRollOption"]
export { _dmgRollOption0 as "dmgRollOption" }
